// @ts-check
import { objectEntries } from '@erpagroapp/common';
import { useSettingRef } from './main';
import { hasValuesInLocalStorage } from './settingsValues';

/**
 * @type {Record<import('./types').PiniaStoresMigrations,
 * Record<string, import('./configsSettings').SettingsKeys>>}
 */
const dataToMigrate = {
  appConfig: {
    'automaticUpdateAlertERP': 'Alertas.ActualizarAutomaticamente',
    'automaticUpdateIntervalAlertERP': 'Alertas.TiempoActualizacionAutomatica',

    'language': 'App.Idioma',
    'urlApp': 'App.URLWebService',
    'logoApp': 'App.Logo',

    'informationBarSettings.showInformationBar': 'BarraInformacion.MostrarBarra',
    'informationBarSettings.showUsername': 'BarraInformacion.MostrarNombreUsuario',
    'informationBarSettings.showRoute': 'BarraInformacion.MostrarRuta',
    'informationBarSettings.showCenter': 'BarraInformacion.MostrarCentro',
    'informationBarSettings.showAppVersion': 'BarraInformacion.MostrarVersionApp',
    'informationBarSettings.order': 'BarraInformacion.OrdenElementos',

    'sideNavbarSettings.showSideNavbar': 'BarraNavegacionLateral.MostrarBarra',
    'sideNavbarSettings.showPalletizing': 'BarraNavegacionLateral.MostrarPaletizado',
    'sideNavbarSettings.showMultiplePalletizing': 'BarraNavegacionLateral.MostrarPaletizadoMultiple',
    'sideNavbarSettings.showManageProductionLines': 'BarraNavegacionLateral.MostrarGestionarLineasProduccion',
    'sideNavbarSettings.showProductionOrdersStatus': 'BarraNavegacionLateral.MostrarEstadoPedidosProduccion',
    'sideNavbarSettings.showManageProductionOutputs': 'BarraNavegacionLateral.MostrarGestionarSalidasProduccion',
    'sideNavbarSettings.order': 'BarraNavegacionLateral.OrdenElementos',
  },
  commercialisation: {
    mostrarFirmaRetornables: 'Retornables.MostrarFirma',
  },
  expeditions: {
    mostrarNombreDireccion: 'Expediciones.MostrarNombreDireccion',
  },
  traceability: {
    'replanificarCantidadPaleTraspasadoOReprocesadoAutomaticamente': 'Picking.ReplanificarCantidadPaleTraspasadoOReprocesadoAutomaticamente',
    'lecturaCodigoBarrasPorDefecto': 'Volcado.LecturaCodigoBarrasPorDefecto',
    'confirmacionAntesDeVolcar': 'Volcado.ConfirmacionAntesDeVolcar',
    'volcadoPorNFCActivo': 'Volcado.VolcarPorLecturaNFC',
    'volcadoPorNFCTrabajarConIdReversed': 'Volcado.VolcarPorLecturaNFCTrabajarConIdInverso',
    'lineaEstablecidaPorDefecto': 'Volcado.LineaProduccionEstablecidaPorDefecto',
    'puntoEstablecidoPorDefecto': 'Volcado.PuntoVolcadoEstablecidoPorDefecto',
    'permitirLoginNFC': 'App.PermitirLoginNFC',
    'campoOrdenacionPuntosPaletizado': 'PuntosPaletizado.CampoOrdenacionPuntosPaletizado',
    'configuracionPuntoPaletizado.PaleActivo.Visualizar': 'Paletizado.PaleActivo.MostrarInformacion',
    'configuracionPuntoPaletizado.PaleActivo.MostrarNumeroSerie': 'Paletizado.PaleActivo.MostrarNumeroSerie',
    'configuracionPuntoPaletizado.PaleActivo.MostrarProducto': 'Paletizado.PaleActivo.MostrarProducto',
    'configuracionPuntoPaletizado.PaleActivo.MostrarEnvase': 'Paletizado.PaleActivo.MostrarEnvase',
    'configuracionPuntoPaletizado.PaleActivo.MostrarPale': 'Paletizado.PaleActivo.MostrarPale',
    'configuracionPuntoPaletizado.PaleActivo.MostrarEnvasesPorPale': 'Paletizado.PaleActivo.MostrarEnvasesPorPale',
    'configuracionFinPaleFrmPaletizado.ImprimirEtiquetaFinPale': 'Paletizado.FinPale.ImprimirEtiqueta',
    'configuracionFinPaleFrmPaletizado.PesajeFinPale': 'Paletizado.FinPale.Pesaje',
    'mostrarTrabajadores': 'RegistroCajas.MostrarTrabajadores',
    'activarAlertasYNotificaciones': 'Alertas.ActivarConFiltro',
    'filtrarAlertasYNotificacionesPorLineaYPuntoDePaletizadoSeleccionado': 'Trazabilidad.Alertas.FiltrarPorLineaYPuntoPaletizadoSeleccionado',
    'mostrarAlertasYNotificacionesDePedidosModificados': 'Trazabilidad.Alertas.MostrarAlertasPedidosModificados',
    'mostrarAlertasYNotificacionesDePlanificacionesYDesplanificaciones': 'Trazabilidad.Alertas.PlanificacionesYDesplanificaciones',
    'configuracionLecturaPaleFrmPaletizado.UtilizarFlash': 'Paletizado.LecturaPale.UtilizarFlash',
    'configuracionLecturaPaleFrmPaletizado.OrientacionCamaraLecturaCodigos': 'Paletizado.LecturaPale.OrientacionCamaraLecturaCodigos',
    'configuracionLecturaCajasFrmPaletizado.LecturaContinuaCodigosBarras': 'Paletizado.LecturaCajas.LecturaContinuaCodigosBarras',
    'configuracionLecturaCajasFrmPaletizado.LecturaContinuaCodigosBarrasManual': 'Paletizado.LecturaCajas.LecturaContinuaCodigosBarrasManual',
    'configuracionLecturaCajasFrmPaletizado.UtilizarFlash': 'Paletizado.LecturaCajas.UtilizarFlash',
    'configuracionLecturaCajasFrmPaletizado.OrientacionCamaraLecturaCodigos': 'Paletizado.LecturaCajas.OrientacionCamaraLecturaCodigos',
    'configuracionLecturaRegistroActividadFrmPaletizado.LecturaContinuaCodigosBarras': 'Paletizado.LecturaRegistroActividad.LecturaContinuaCodigosBarras',
    'configuracionLecturaRegistroActividadFrmPaletizado.LecturaContinuaCodigosBarrasManual': 'Paletizado.LecturaRegistroActividad.LecturaContinuaCodigosBarrasManual',
    'configuracionLecturaRegistroActividadFrmPaletizado.UtilizarFlash': 'Paletizado.LecturaRegistroActividad.UtilizarFlash',
    'configuracionLecturaRegistroActividadFrmPaletizado.OrientacionCamaraLecturaCodigos': 'Paletizado.LecturaRegistroActividad.OrientacionCamaraLecturaCodigos',
    'configuracionLecturaCajasFrmPicking.LecturaContinuaCodigosBarras': 'Picking.LecturaCajas.LecturaContinuaCodigosBarras',
    'configuracionLecturaCajasFrmPicking.LecturaContinuaCodigosBarrasManual': 'Picking.LecturaCajas.LecturaContinuaCodigosBarrasManual',
    'configuracionLecturaCajasFrmPicking.UtilizarFlash': 'Picking.LecturaCajas.UtilizarFlash',
    'configuracionLecturaCajasFrmPicking.OrientacionCamaraLecturaCodigos': 'Picking.LecturaCajas.OrientacionCamaraLecturaCodigos',
  },
  warehouse: {
    campoFormaRecuento: 'InventarioRegularizacion.FormaRecuento',
  },
};

/**
 * Retrieve nested property value based on a dot-separated key.
 *
 * @param {Record<string, any>} obj - The object to retrieve the value from.
 * @param {string} path - The dot-separated path to the property.
 * @returns {any} The nested value or undefined.
 */
function getNestedValue(obj, path) {
  return path.split('.').reduce((acc, key) => acc && acc[key], obj);
}

export function migrateSettingsFromPinia() {
  if (hasValuesInLocalStorage()) {
    // The parameters have already been migrated
    return;
  }

  for (const [storeName, paramMappings] of objectEntries(dataToMigrate)) {
    const piniaStateStorage = localStorage.getItem(storeName);

    if (piniaStateStorage) {
      const parsedPiniaState = /** @type {Partial<Record<string, never>>} */ (JSON.parse(piniaStateStorage));

      for (const [piniaStateName, settingsKey] of objectEntries(paramMappings)) {
        const piniaStateValue = getNestedValue(parsedPiniaState, piniaStateName);

        if (piniaStateValue !== undefined) {
          const settingRef = useSettingRef(settingsKey);
          settingRef.value = /** @type {never} */ (piniaStateValue);
        }
      }
    }
  }

  // Special handling for 'configuracionLecturaCajasFrmPicking.OtrasOpciones[0].Valor'
  const traceabilityStateStorage = localStorage.getItem('traceability');
  if (traceabilityStateStorage) {
    const parsedTraceabilityState = JSON.parse(traceabilityStateStorage);
    const otrasOpciones = getNestedValue(parsedTraceabilityState, 'configuracionLecturaCajasFrmPicking.OtrasOpciones');

    if (Array.isArray(otrasOpciones) && otrasOpciones.length > 0 && otrasOpciones[0]?.Valor !== undefined) {
      const settingRef = useSettingRef('Picking.LecturaCajas.LecturaEnTraspaso');
      settingRef.value = otrasOpciones[0].Valor;
    }
  }
}
